module.exports = __webpack_public_path__ + "static/img/img_guide2.cb987574.png";